import React from "react";
import Autocomplete from "../../components/Autocomplete";
import { wait } from "../../utils/mock";

const fetchEmployeeOptions = async ({ filter }) => {
    await wait(650);
    return [...Array(10).keys()].map((id) => ({ id, name: `Firstname Surname ${id}` }));
};

export const EmployeeSelect = ({ value, onChange, fullWidth = true, ...props }) => {
    //autoSelect
    return (
        <Autocomplete
            fullWidth={fullWidth}
            {...props}
            fetchOptions={fetchEmployeeOptions}
            getOptionLabel={(option) => option.name}
            value={value || null}
            onChange={(e, val) => {
                if (typeof val === "string") {
                    val = { name: val };
                }
                onChange && onChange(val);
            }}
            onBlur={(e) => {
                if (!value || !value.id) {
                    onChange && onChange(e.target.value ? { name: e.target.value } : null);
                }
            }}
            freeSolo
            clearable
        />
    );
};
